import { useCallback, useRef, useState } from 'react';

export const useTextFieldLabelRef = () => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const [labelElement, setLabelElement] = useState<HTMLLabelElement | null>(null);

  const setRef = useCallback((node: HTMLDivElement | null) => {
    wrapperRef.current = node;

    if (node) {
      const label = node.querySelector<HTMLLabelElement>('.MuiFormLabel-root');
      setLabelElement(label);
    } else {
      setLabelElement(null);
    }
  }, []);

  return {
    wrapperRef: setRef,
    labelElement,
  };
};
